import apiFetch from '../../apiFetch'

export default function (ouId, dossierSubTypeId, month, token) {
  return apiFetch({ endPoint: `dossier/service/notavailabledays/${ouId}?dossierSubtypeId=${dossierSubTypeId}&monthSelected=${month}`, method: 'GET', token: token })
}
